// 現在再生中の動画を追跡する変数
let currentlyPlayingVideo = null;
let currentlyPlayingThumbnail = null;

// 動画を停止してサムネイルに戻す関数
function stopCurrentVideo() {
  if (currentlyPlayingVideo && currentlyPlayingThumbnail) {
    const video = currentlyPlayingVideo;
    const thumbnail = currentlyPlayingThumbnail;

    // 動画を停止
    video.pause();
    video.currentTime = 0;

    // サムネイルに戻す
    video.style.opacity = '0';
    setTimeout(() => {
      video.style.display = 'none';
      thumbnail.style.display = 'block';
      thumbnail.style.opacity = '0';
      setTimeout(() => {
        thumbnail.style.opacity = '1';
      }, 50);
    }, 500);

    // 再生中の動画の参照をクリア
    currentlyPlayingVideo = null;
    currentlyPlayingThumbnail = null;
  }
}

// 汎用的な動画再生関数
window.playVideo = function(videoId) {
  const video = document.getElementById(videoId);
  const thumbnail = document.querySelector(`[data-video-id="${videoId}"]`);

  if (!video || !thumbnail) {
    console.error('動画またはサムネイル要素が見つかりません:', videoId);
    return;
  }

  // 既にこの動画が再生中の場合は何もしない
  if (currentlyPlayingVideo === video) {
    return;
  }

  // 他の動画が再生中の場合は停止する
  stopCurrentVideo();

  // 新しい動画を再生中の動画として設定
  currentlyPlayingVideo = video;
  currentlyPlayingThumbnail = thumbnail;

  // サムネイルをフェードアウトして動画を表示
  thumbnail.style.opacity = '0';
  setTimeout(() => {
    thumbnail.style.display = 'none';
    video.style.display = 'block';
    video.style.opacity = '0';
    setTimeout(() => {
      video.style.opacity = '1';
    }, 50);
  }, 500);

  // 動画を再生
  video.play();

  // 動画が終了したらサムネイルに戻す
  video.addEventListener('ended', function() {
    stopCurrentVideo();
  }, { once: true });
};

// 動画が終了したらサムネイルに戻すイベントリスナー（一度だけ登録）
document.addEventListener('DOMContentLoaded', function() {
  let scrollPosition = 0;
  const modal = document.querySelector('.modal.modalOverview');
  const content = document.getElementById('content');
  const mainCol = document.getElementById('main-col');

  // モーダルを#content内に移動
  if (modal && content) {
    content.appendChild(modal);
  }

  function openModal() {
    scrollPosition = window.scrollTop || window.pageYOffset;
    modal.classList.add('is-active');
    mainCol.style.cssText = 'position: fixed; width: 100%; top: ' + -scrollPosition + 'px;';
  }

  function closeModal() {
    modal.classList.remove('is-active');
    mainCol.style.cssText = '';
    window.scrollTo(0, scrollPosition);
  }

  // モーダルを開く
  document.addEventListener('click', function(e) {
    if (e.target.closest('.modalBtn')) {
      e.preventDefault();
      openModal();
    }
    // 閉じる処理
    else if (e.target.classList.contains('closeModal') || e.target.closest('.closeModal')) {
      e.preventDefault();
      closeModal();
    }
    // エリア外クリック
    else if (modal.classList.contains('is-active') && e.target === modal || e.target.classList.contains('modalOverlay')) {
      closeModal();
    }
  });

  const video = document.getElementById('case-study-video');
  if (video) {
    // 既存のイベントリスナーを削除してから新しいものを追加
    video.removeEventListener('ended', handleVideoEnd);
    video.addEventListener('ended', handleVideoEnd);
  }

  // SPサイズ時（800px以下）に.real-voiceを開閉式にする
  initRealVoiceToggle();
});

// 動画終了時の処理を関数として分離
function handleVideoEnd() {
  const video = document.getElementById('case-study-video');
  const thumbnail = document.querySelector('.video-thumbnail');

  if (video && thumbnail) {
    video.style.display = 'none';
    thumbnail.style.display = 'block';
  }
}

// SPサイズ時（800px以下）に.real-voiceを開閉式にする
function initRealVoiceToggle() {
  const realVoices = document.querySelectorAll('.real-voice');
  const isSP = () => window.innerWidth <= 800;

  realVoices.forEach(realVoice => {
    const paragraphs = realVoice.querySelectorAll('p');
    if (paragraphs.length <= 2) return; // 2つ以下の場合は開閉不要

    // ボタンコンテナを作成
    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'real-voice-toggle-container';

    const toggleButton = document.createElement('button');
    toggleButton.className = 'real-voice-toggle-btn';

    const buttonText = document.createElement('span');
    buttonText.className = 'btn-text';
    buttonText.textContent = 'さらに読み込む';

    const buttonIcon = document.createElement('span');
    buttonIcon.className = 'btn-icon';
    // 矢印アイコン（arrow-wh.svgを使用）
    const svgPath = window.location.origin + '/wp/wp-content/themes/seikatsusoken/assets/img/digital-analog2025/part2/arrow-wh.svg';

    // SVGファイルを読み込んでインライン化
    fetch(svgPath)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(svgText => {
        // SVGをパースしてDOMに追加
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
        const svgElement = svgDoc.querySelector('svg');
        if (svgElement) {
          // SVGのサイズとスタイルを設定
          svgElement.setAttribute('width', '16');
          svgElement.setAttribute('height', '25');
          svgElement.setAttribute('fill', 'currentColor');
          // SVGをクローンして追加（元のドキュメントから切り離す）
          buttonIcon.appendChild(document.importNode(svgElement, true));
        } else {
          throw new Error('SVG要素が見つかりませんでした');
        }
      })
      .catch(error => {
        console.error('SVG読み込みエラー:', error);
        console.error('SVGパス:', svgPath);
        // フォールバック: シンプルな矢印を表示
        const svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svgIcon.setAttribute('width', '16');
        svgIcon.setAttribute('height', '25');
        svgIcon.setAttribute('viewBox', '0 0 16 25');
        svgIcon.setAttribute('fill', 'currentColor');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M8 25L0 15h6V0h4v15h6L8 25z');
        svgIcon.appendChild(path);
        buttonIcon.appendChild(svgIcon);
      });

    toggleButton.appendChild(buttonText);
    toggleButton.appendChild(buttonIcon);
    buttonContainer.appendChild(toggleButton);

    let isExpanded = false;
    // 「さらに読み込む」ボタンをクリックした時の位置を保存
    let expandButtonPosition = 0;

    // 初期状態の設定
    function updateVisibility() {
      if (isSP()) {
        // SPサイズ時：最初の2つまで表示
        paragraphs.forEach((p, index) => {
          if (index < 2) {
            p.style.display = 'block';
          } else {
            p.style.display = isExpanded ? 'block' : 'none';
          }
        });
        buttonContainer.style.display = 'flex';
        realVoice.classList.toggle('is-expanded', isExpanded);
      } else {
        // PCサイズ時：全て表示
        paragraphs.forEach(p => {
          p.style.display = 'block';
        });
        buttonContainer.style.display = 'none';
        isExpanded = false;
        realVoice.classList.remove('is-expanded');
      }
    }

    // ボタンクリック時の処理
    toggleButton.addEventListener('click', function() {
      if (!isSP()) return;

      if (isExpanded) {
        // 閉じる処理
        paragraphs.forEach((p, index) => {
          if (index < 2) {
            p.style.display = 'block';
          } else {
            p.style.display = 'none';
          }
        });
        isExpanded = false;
        realVoice.classList.remove('is-expanded');

        // 保存した「さらに読み込む」ボタンの位置までスクロール
        if (expandButtonPosition > 0) {
          window.scrollTo({
            top: expandButtonPosition,
            behavior: 'smooth'
          });
        }
      } else {
        // 展開処理：全てのアイテムを表示
        // 「さらに読み込む」ボタンの位置を保存（ボタンの下端がビューポートの下部から80px上に来る位置）
        const rect = toggleButton.getBoundingClientRect();
        expandButtonPosition = window.scrollY + rect.bottom - window.innerHeight + 80;

        paragraphs.forEach((p, index) => {
          if (index < 2) {
            p.style.display = 'block';
          } else {
            p.style.display = 'block';
          }
        });
        isExpanded = true;
        realVoice.classList.add('is-expanded');
      }

      buttonText.textContent = isExpanded ? '閉じる' : 'さらに読み込む';
    });

    // 初期状態を設定
    updateVisibility();

    // real-voiceの後にボタンを追加
    realVoice.appendChild(buttonContainer);

    // リサイズ時の処理
    window.addEventListener('resize', updateVisibility);
  });
}
